import { defineStore } from "pinia"

/* Permet de communiquer dans toute l'application sur un état
d'erreur!
Par exemple si le serveur backend est inaccessible */
const useErrorStore = defineStore('error', {
  state: () => {
    return {
      error: false
    }
  }
})

export default useErrorStore
